/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import CaseActionsArchiveButton from './CaseActionsArchiveButton';

const useStyles = makeStyles(() => {
  return {
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
  };
});

export default ({ onCaseAction, auth, isArchiving$ }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" style={{ textAlign: 'left' }}>
      <Grid item>
        <Typography className={classes.sectionHeader}>Report information</Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.sectionText}>This case has been picked up</Typography>
      </Grid>
      <Grid item>
        <div className="pt-1">
          <CaseActionsArchiveButton auth={auth} isArchiving$={isArchiving$} onCaseAction={onCaseAction} />
        </div>
      </Grid>
    </Grid>
  );
};
